module.exports = __webpack_public_path__ + "static/media/menu-profile-selected.ab23f81d.svg";